import type { FaireProductEntity } from "../../entity_types/product";

export const p_c80cn240m1: FaireProductEntity = {
  token: "p_c80cn240m1",
  type: "product",
  name: "15PC Truffles Gourmet Premium Assortment- Window Box",
  brandToken: "b_77h2e37s1r",
  brandName: "O'Shea's Candies Sweet Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/27af46dcecbde02fbe70a36c4d82f03d8f36eb13efa2e716a58f2cc75a81e189.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5ab661b070e84440c6e095317b19a47ac00023de09796cf66cdb5d2fc65b645.jpeg",
    "https://cdn.faire.com/fastly/24a51cdeb1c8445de3ad4c4589b60f2e430e740ebfc78801e3298d0994bc0e92.jpeg",
    "https://cdn.faire.com/fastly/e44b919248cce594714c665475d58205ea4a044dd8dedb63ebfd2e804a292b89.jpeg",
    "https://cdn.faire.com/fastly/fb2fd5a248d9cc1e50c9bd097ea24d2e9569ac05e77e2a9f2680d90478d9ff84.jpeg",
    "https://cdn.faire.com/fastly/e68ce73c8362db33aba3c4a070c53fe6127c5bd2d2357788763e8cdf32dfca34.jpeg",
  ],
  priceDollars: 17.99,
  description:
    "Great gift item that includes over 15 different kinds of Mini Gourmet Truffles.  Each chocolate truffle are made with the finest ingredients - including fresh heavy cream right from a family farm. These truffles are naturally Gluten-Free. Great variety of milk -dark- & white chocolate for a full colorful assortment.  Each is cupped & decorated in a old fashioned window box.   Each mini truffle is meticulously crafted with a ganache filling made from a harmonious blend of high-quality chocolate and rich cream. The ganache is carefully infused with various flavors, to create a diverse selection of truffles.\n\nThe ganache filling is then carefully enrobed in a thin layer of premium milk chocolate, creating a delicate and smooth exterior. The mini size of these truffles makes them perfect for savoring and enjoying in a single, decadent bite.  Each is hand decorated.\n\nWhen you indulge in a mini gourmet ganache truffle, the thin milk chocolate shell gently gives way to the vel",
  tags: [],
  msrpDollars: 27.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:16.654Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
